import React from 'react'

const RTIReplies = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>RTI Replies</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <p>Content is not available</p>
      </div>
    </div>
  )
}

export default RTIReplies
